/* eslint-disable @typescript-eslint/no-var-requires */
const businessDays = require('business-days-js');

export const getNextBusinessDay = (date: string): string => businessDays().addDays(date, 1).format('YYYY-MM-DD');
